"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQueryOperationMoveRewrite = void 0;
const bus_query_operation_1 = require("@comunica/bus-query-operation");
const sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A [Query Operation](https://github.com/comunica/comunica/tree/master/packages/bus-query-operation) actor that
 * handles SPARQL move operations.
 */
class ActorQueryOperationMoveRewrite extends bus_query_operation_1.ActorQueryOperationTypedMediated {
    constructor(args) {
        super(args, 'move');
        this.factory = new sparqlalgebrajs_1.Factory();
    }
    async testOperation(operation, context) {
        bus_query_operation_1.ActorQueryOperation.throwOnReadOnly(context);
        return true;
    }
    runOperation(operationOriginal, context) {
        // No-op if source === destination
        if ((typeof operationOriginal.destination === 'string' && typeof operationOriginal.source === 'string' &&
            operationOriginal.destination === operationOriginal.source) ||
            (typeof operationOriginal.destination !== 'string' && typeof operationOriginal.source !== 'string' &&
                operationOriginal.destination.equals(operationOriginal.source))) {
            return Promise.resolve({
                type: 'void',
                execute: () => Promise.resolve(),
            });
        }
        // MOVE is equivalent to drop destination, add, and drop source
        const updates = [
            this.factory.createDrop(operationOriginal.destination, true),
            this.factory.createAdd(operationOriginal.source, operationOriginal.destination, operationOriginal.silent),
            this.factory.createDrop(operationOriginal.source),
        ];
        const operation = this.factory.createCompositeUpdate(updates);
        return this.mediatorQueryOperation.mediate({ operation, context });
    }
}
exports.ActorQueryOperationMoveRewrite = ActorQueryOperationMoveRewrite;
//# sourceMappingURL=ActorQueryOperationMoveRewrite.js.map